import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { Navigate, useLocation } from 'react-router';

type RequireNoAuthProps = {
  children: React.ReactNode;
};

function RequireNoAuth({ children }: RequireNoAuthProps) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoggedIn) {
    if (location.pathname === LINKS.LOGIN && auth.details && auth.details['username']) {
      return <Navigate to={`/${auth.details['username']}`} state={{ from: location }} replace />;
    }

    return <Navigate to={LINKS.HOME} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default RequireNoAuth;
